<script lang="ts">
  import syntheticsVideo from '$lib/assets/branding/synthetics-homepage.mp4'
  import SyntheticsCard from './SyntheticsCard.svelte'
  import BlackVectorSvg from '../../components/SVGs/BlackVectorSVG.svelte'
  import LargeCircle from '../../components/SVGs/LargeCircleSVG.svelte'
  import SmallCircleSvg from '../../components/SVGs/SmallCircleSVG.svelte'
  import { deferVideo } from '$lib/attachments/deferVideo'

  const values = [
    {
      title: 'A synthetic asset mimics the value of real-world assets in crypto.',
    },
    {
      title: 'You don’t own the actual asset you’re investing in.',
    },
    {
      title: 'Assets frequently employed for trading, investing, or hedging.',
    },
    {
      title: 'Investors hold a financial instrument that replicates its value.',
    },
    {
      title: 'An example:<br/> 1 BTC = 1 BTCb',
    },
  ]
</script>

<div class="mx-auto max-w-[1655px] rounded-lg bg-[#24CAFF] lg-desktop:pb-20">
  <section class="relative m-2 mx-auto flex max-w-[1440px] flex-col justify-between overflow-hidden pb-8 text-black">
    <div class="lg-desktop:mx-auto lg-desktop:mt-[2rem]">
      <div class="relative top-[50px] z-[1] flex flex-col items-center">
        <LargeCircle
          svgStyles="clip-top absolute top-[7vw] z-[0] w-screen scale-[1.15] sm:top-[25px] sm:h-auto sm:w-[640px] sm:scale-[1.1] md:h-[850px] md:w-[850px] lg-desktop:top-[-80px] lg-desktop:h-[1200px] lg-desktop:w-[1200px] lg-desktop:scale-x-[1.15]"
        />
        <h2
          class="relative top-[-25px] z-[2] w-[82%] bg-[#24CAff] pt-8 text-center font-cirka text-[14vw] uppercase leading-[100%] text-black xs-tablet:w-[400px] xs-tablet:text-[70px] lg-desktop:w-[1050px] lg-desktop:text-[190px]"
        >
          Synthetic
        </h2>
        <p
          class="relative -top-8 z-[2] w-[52%] bg-[#24CAff] text-center font-cirka text-[14vw] uppercase leading-[100%] text-black sm:w-[min] xs-tablet:w-[250px] xs-tablet:text-[70px] lg-desktop:-top-[50px] lg-desktop:w-[620px] lg-desktop:text-[190px]"
        >
          Assets
        </p>
        <div style="pointer-events: none;">
          <video
            {@attach deferVideo()}
            autoplay
            data-src={syntheticsVideo}
            class="clip-video relative -top-[95px] z-[2] max-h-[500px] scale-[0.9] lg-desktop:top-[-250px] lg-desktop:h-[835px] lg-desktop:max-h-[unset] lg-desktop:w-[815px] lg-desktop:scale-[0.75]"
            playsinline
            loop
            muted
            defaultMuted
            disableremoteplayback
            oncontextmenu={(event) => event.preventDefault()}
            preload="none"
          >
          </video>
        </div>
        <SmallCircleSvg
          svgStyles="absolute top-[18%] z-[1] w-[85%] scale-[1.12] scale-y-[1.2] sm:w-[500px] lg-desktop:top-[10%] lg-desktop:h-[830px] lg-desktop:w-[830px]"
        />
      </div>

      <BlackVectorSvg svgStyles="top-[700px] left-[17.6%] scale-125 rotate-[-10deg]" />
      <BlackVectorSvg svgStyles="top-[88.4%] left-[25%] rotate-[35deg] scale-125" />
      <BlackVectorSvg svgStyles="top-[60%] right-[19.2%] rotate-[20deg] scale-125" />
      <SyntheticsCard
        title={values[0].title}
        cardStyles="hidden lg-desktop:flex lg-desktop:absolute top-[33%] left-[10%] "
      />
      <SyntheticsCard
        title={values[1].title}
        cardStyles="hidden lg-desktop:flex lg-desktop:absolute top-[66%] left-[15%] lg-desktop:w-[240px]"
        textStyles="w-[184px]"
      />
      <SyntheticsCard
        title={values[2].title}
        cardStyles="hidden lg-desktop:flex lg-desktop:absolute top-[45%] right-[8%]"
      />
      <SyntheticsCard
        title={values[3].title}
        cardStyles="hidden lg-desktop:flex lg-desktop:absolute bottom-[18%] right-[22%] "
      />
      <SyntheticsCard
        title={values[4].title}
        cardStyles="hidden lg-desktop:flex lg-desktop:absolute bottom-[0%] left-[40%]"
      />

      <ul
        class="relative z-[2] mt-[3rem] grid grid-cols-[repeat(auto-fit,minmax(312px,1fr))] justify-items-center space-y-2 rounded-[50px] sm:top-[-35px] sm:items-end sm:space-y-8 md:mx-6 md:grid-cols-3 md:space-y-0 lg-desktop:hidden"
      >
        <SyntheticsCard title={values[0].title} />
        <SyntheticsCard title={values[1].title} cardStyles="md:row-start-3 md:col-start-1" />
        <SyntheticsCard title={values[2].title} cardStyles="md:row-start-1 md:col-start-3" />
        <SyntheticsCard title={values[3].title} cardStyles="md:col-start-3" />
        <SyntheticsCard title={values[4].title} cardStyles="md:row-start-2 md:col-start-1 md:col-end-[none] " />
      </ul>
    </div>
  </section>
</div>

<style>
  .clip-video {
    clip-path: inset(5% 3% 3% 3% round 100% 100% 100% 100%);
  }

  @media (min-width: 1440px) {
    section > div {
      max-width: 1440px;
      margin-left: auto;
      margin-right: auto;
    }
    :global(.clip-top) {
      clip-path: inset(10% 0 0 0);
    }
  }
</style>
